import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { DEFAULT_MULTI_ADDRESS_STAGE_NUMBER_OF_ADDRESSES_TO_SHOW } from 'containers/Checkout/constants'
import { displayMoreAddresses, selectSingleAddress } from 'containers/stages/MultipleAddressStage/actions'
import styles from './styles.scss'

export class AddressScrollPickerComponent extends PureComponent {
  static propTypes = {
    viewMore: PropTypes.func,
    makeSelection: PropTypes.func,
    selectedAddress: PropTypes.string,
    addresses: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      address: PropTypes.string,
    })),
    numAddressesToShow: PropTypes.number,
    error: PropTypes.string,
  }

  static defaultProps = {
    viewMore: f => f,
    makeSelection: f => f,
    selectedAddress: null,
    addresses: [],
    error: null,
    numAddressesToShow: DEFAULT_MULTI_ADDRESS_STAGE_NUMBER_OF_ADDRESSES_TO_SHOW,
  }

  onChange = (event) => {
    this.props.makeSelection(event.target.value)
  }

  getMappedElements = () => {
    const mapped = this.props.addresses.slice(0, this.props.numAddressesToShow).map((item) => {
      const [street, suburb] = item.address.split(',')
      return (
        <div key={item.id} className={styles.option}>
          <input
            id={item.id}
            onChange={this.onChange}
            type="radio"
            value={item.id}
            checked={item.id === this.props.selectedAddress}
          />
          <label htmlFor={item.id}>
            <span className={styles.icon} />
            <div className={styles.labelText}>
              <span className={styles.labelTextMain}>{ street }</span><br />
              <span className={styles.labelTextSecondary}>{ suburb }</span>
            </div>
          </label>
        </div>
      )
    })
    return mapped
  }

  viewMoreComponent = () => (
    this.props.numAddressesToShow < this.props.addresses.length ? (
      <div className={styles.option}>
        <button type="button" className={styles.viewMore} onClick={this.props.viewMore}>View More</button>
      </div>
    ) : null
  )

  render() {
    const mappedElements = this.getMappedElements()
    const viewMore = this.viewMoreComponent()
    const errorMessage = this.props.error ? <p className={styles.error}> { this.props.error }</p> : null
    return (
      <div>
        <div className={styles.wrapper}>
          { mappedElements }
          { viewMore }
        </div>
        { errorMessage }
      </div>
    )
  }
}

function mapStateToProps(state) {
  // whatever is returned will show up as props
  return {
    selectedAddress: state.checkoutReducer.multiAddressStageSelectedId,
    numAddressesToShow: state.checkoutReducer.multiAddressStageNumAddressesToShow,
  }
}

// Anything returned from this function will end up as props
function mapDispatchToProps(dispatch) {
  // Whenever dispatch is called the result should be passed
  // to all of the reducers
  return bindActionCreators(
    {
      viewMore: displayMoreAddresses,
      makeSelection: selectSingleAddress,
    },
    dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(AddressScrollPickerComponent)



// WEBPACK FOOTER //
// ./components/form/AddressScrollPicker/index.jsx